import React from "react";
import AddGastoForm from "./AddGastoForm";

const AddGasto = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Gasto"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddGastoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddGasto;
